//import * as app from 'firebase';
import app from 'firebase/app';
import 'firebase/auth';

const config = {
  apiKey: "AIzaSyBvZcZR9xmOvlfF4LYc6vGmCphdjKZpxWE",
  authDomain: "security-map-259117.firebaseapp.com",
  databaseURL: "https://security-map-259117.firebaseio.com",
  projectId: "security-map-259117",
  storageBucket: "security-map-259117.appspot.com",
  messagingSenderId: "488772920053",
  appId: "1:488772920053:web:2131057081d950c96b1bbc",
  measurementId: "G-Q5XRLP7Y8V",
  messagingSenderId: "488772920053",
};

class Firebase {
  constructor() {
    app.initializeApp(config);
    this.auth = app.auth();
  }

  // *** Auth API ***
  doCreateUserWithEmailAndPassword = (email, password) =>
    this.auth.createUserWithEmailAndPassword(email, password);

  doSignInWithEmailAndPassword = (email, password) =>
    this.auth.signInWithEmailAndPassword(email, password);

  doSignOut = () => this.auth.signOut();

  doPasswordReset = email => this.auth.sendPasswordResetEmail(email);

  doPasswordUpdate = password =>
    this.auth.currentUser.updatePassword(password);
}


export default Firebase;
